import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWoocommerceComponent } from './simple-icons-woocommerce.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWoocommerceComponent ],
    exports:      [ SimpleIconsWoocommerceComponent ],
    bootstrap:    []
})
export class SimpleIconsWoocommerceModule {}
